import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { CampaignTypes } from '../../../Codes'
import RadioButton from '../../../../components/form/RadioButton'
import CheckBox from '../../../../components/form/CheckBox'
import ErrorText from '../../../../components/form/ErrorText'
import { setDeviceSettingType, toggleDeviceType } from '../adGroupSlice'

const Device = ({ error }) => {
  const dispatch = useDispatch()
  const {
    campaign: {
      form: { campaignType },
    },
    adGroup: {
      form: { deviceSettingType, deviceTypes },
    },
  } = useSelector(state => state.ad)
  const handleDeviceSettingTypeChange = useCallback(
    value => dispatch(setDeviceSettingType(value)),
    [dispatch]
  )
  const handleDeviceTypeChange = useCallback(
    ({ target: { value } }) => dispatch(toggleDeviceType(value)),
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">디바이스</strong>
      <div className="cont_card">
        {campaignType === CampaignTypes.TALK_CHANNEL ? (
          <p className="desc_g">모바일</p>
        ) : (
          <div className="item_crad">
            <ul className="list_radiocheck">
              <li>
                <RadioButton
                  name="deviceSettingType"
                  value="ALL"
                  label="전체"
                  tiaraAction="디바이스_전체_클릭"
                  checked={deviceSettingType === 'ALL'}
                  onValueChange={handleDeviceSettingTypeChange}
                />
              </li>
              <li>
                <RadioButton
                  name="deviceSettingType"
                  value="SETTING"
                  label="상세설정"
                  tiaraAction="디바이스_상세설정_클릭"
                  checked={deviceSettingType === 'SETTING'}
                  onValueChange={handleDeviceSettingTypeChange}
                />
              </li>
            </ul>
            {deviceSettingType === 'SETTING' && (
              <div className="box_subcard">
                <strong className="screen_out">디바이스 상세 설정</strong>
                <ul className="list_radiocheck">
                  <li>
                    <CheckBox
                      label="모바일"
                      name="deviceTypes"
                      value="MOBILE"
                      tiaraAction="디바이스_모바일_클릭"
                      checked={deviceTypes.includes('MOBILE')}
                      onChange={handleDeviceTypeChange}
                    />
                  </li>
                  <li>
                    <CheckBox
                      label="PC"
                      name="deviceTypes"
                      value="PC"
                      tiaraAction="디바이스_PC_클릭"
                      checked={deviceTypes.includes('PC')}
                      onChange={handleDeviceTypeChange}
                    />
                  </li>
                </ul>
              </div>
            )}
            <ErrorText error={error} tag="p" />
          </div>
        )}
      </div>
    </div>
  )
}
Device.propTypes = {
  error: PropTypes.string,
}
export default Device
